import { navigate } from '@reach/router';
import React, { useContext, useEffect, useState } from 'react';
import client from '../lib/client';
import { membershipQuery } from '../queries/account';
import {
  MembershipQuery,
  MembershipQueryVariables
} from '../queries/__generated__/MembershipQuery';
import { UserContext } from './UserContext';

export const SELECTED_ACCOUNT_ID = 'selectedAccountId';

export function getAccountId() {
  return localStorage.getItem(SELECTED_ACCOUNT_ID)
}

const initialContext = {
  selectedAccountId: getAccountId() || '',
  currentAccountMemberId: '',
  selectAccount: (accountId: string) => {}
};

const AccountContext = React.createContext(initialContext);

const AccountProvider: React.FC<{ initialAccountId: string }> = ({
  children,
  initialAccountId
}) => {
  const [selectedAccountId, setSelectedAccountId] = useState(initialAccountId);
  const [currentAccountMemberId, setCurrentAccountMemberId] = useState('');
  const [loading, setLoading] = useState(true);

  async function selectAccount(accountId: string) {
    localStorage.setItem(SELECTED_ACCOUNT_ID, accountId);

    await client
      .query<MembershipQuery, MembershipQueryVariables>({
        query: membershipQuery,
        variables: {
          accountId
        }
      })
      .then(result => {
        if (result.data.findMembership!.id) {
          setCurrentAccountMemberId(result.data.findMembership!.id);
          setLoading(false);
        }
      });
    setSelectedAccountId(accountId);
  }

  useEffect(() => {
    async function getAccount() {
      await selectAccount(selectedAccountId);
    }
    if (selectedAccountId) {
      getAccount();
    }
  }, []);

  if (loading) {
    return <div />;
  }

  return (
    <AccountContext.Provider value={{ selectedAccountId, selectAccount, currentAccountMemberId }}>
      {children}
    </AccountContext.Provider>
  );
};

const PleaseSelectAccount: React.FC = ({ children }) => {
  const selectedAccountId = getAccountId();
  const { user } = useContext(UserContext);

  if (!selectedAccountId) {
    localStorage.setItem(SELECTED_ACCOUNT_ID, user.memberships[0].account.id);
    navigate('/');
    return <div />;
  }

  return (
    <AccountProvider initialAccountId={selectedAccountId as string}>{children}</AccountProvider>
  );
};

export { AccountContext, AccountProvider, PleaseSelectAccount };
